<template>
  <div class="border-top border-left border-right">
    <div class="pl-5 border-bottom bg-light">
      <div class="row">
        <div class="col-4 py-3 font-weight-bold">
          Вопрос
        </div>

        <div class="col-8">
          <div class="row">
            <div class="col-4 border-left py-3 font-weight-bold">
              Ответ
            </div>

            <div class="col-4 border-left py-3 font-weight-bold">
              Комментарий клиента
            </div>
            <div class="col-4 border-left py-3 font-weight-bold">
              Комментарий врача
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
        v-for="category in questionnaire.categories"
        :key="category.id">

      <div class="border-bottom font-weight-bold bg-light py-3 px-3">
        {{category.title}}
      </div>

      <div
          v-for="question in category.questions"
          :key="question.id"
          class="border-bottom pl-5">
        <QuestionnaireQuestion
            :question="question"
            :comment-answer="commentAnswer" />
      </div>
    </div>

    <div>
      <div class="border-bottom border-top mt-5 font-weight-bold bg-light py-3 px-3">
        Вопросы с ответами в красной зоне
      </div>

      <div
          v-for="question in danger"
          :key="`danger-${question.id}`"
          class="px-3">
        <a :href="`#${question.id}`">{{question.text}}</a>
      </div>
    </div>

    <div>
      <div class="border-bottom border-top mt-2 font-weight-bold bg-light py-3 px-3">
        Вопросы с ответами в желтой зоне
      </div>

      <div
          v-for="question in warning"
          :key="`warning-${question.id}`"
          class="px-3">
        <a :href="`#${question.id}`">{{question.text}}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import QuestionnaireQuestion from './Question';

  export default {
    name: 'QuestionnaireItem',

    components: {QuestionnaireQuestion},

    props: ['questionnaire', 'commentAnswer'],

    data() {
      return {
        selected: [],
      };
    },

    computed: {
      danger() {
        const questions = [];

        for (const category of this.questionnaire.categories) {
          for (const question of category.questions) {
            const hasDangerAnswers = question.fields.find(f => {
              return typeof f.answer !== 'undefined' && f.level <= 20 && f.level > 0;
            });

            if (typeof hasDangerAnswers !== 'undefined') {
              questions.push(question);
            }
          }
        }

        return questions;
      },

      warning() {
        const questions = [];

        for (const category of this.questionnaire.categories) {
          for (const question of category.questions) {
            const hasWarningAnswers = question.fields.find(f => {
              return typeof f.answer !== 'undefined' && f.level <= 40 && f.level > 20;
            });

            if (typeof hasWarningAnswers !== 'undefined') {
              questions.push(question);
            }
          }
        }

        return questions;
      },
    },
  };
</script>
